module.exports = __webpack_public_path__ + "static/media/slide (10).3f67d9c1.jpg";